<template>
  <div>
    <v-col cols="12" class="mt-5 text-h4 font-weight-light d-flex">
      <div class="white--text">
        <span class="f-title">STREET VIEW STREAM </span>
      </div>
    </v-col>
    <v-row>
      <v-col cols="12" class="mt-1 font-weight-light d-flex">
        <v-btn class="mx-5" @click="start">stream</v-btn>
        <v-btn class="mx-5" @click="stop">stop</v-btn>
      </v-col>

    </v-row>

    <div>
      <draggable :list="widgets" handle=".handle" group="widgets" class="row px-3">
        <t-s-widget v-for="w in widgets" v-bind="w" :key="w.id" :isSplit="split" :fluxItem="fluxItem"
          @refresh="onRefresh" @split="onSplit" @loaded="onLoaded" />
      </draggable>
      <v-btn v-show="split" id="unsplit-btn" color="orange" dark @click="onSplit(false)" fab
        transition="scale-transition">
        <v-icon>mdi-arrow-collapse-vertical</v-icon>
      </v-btn>
    </div>
    <t-s-photo-gallery />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { TSCommonMixin } from '@/mixins/TSCommonMixin'
import draggable from 'vuedraggable'
import TSPhotoGallery from '@/components/common/TSPhotoGallery'
import TSWidget from '@/components/flux/widgets/TSWidget'
export default {
  name: 'StreetViewStream',
  components: {
    draggable,
    TSPhotoGallery,
    TSWidget,
  },
  mixins: [TSCommonMixin],
  data: () => ({
    loading: true,
    split: false,
    isMapboxReady: false,
    isStreetViewReady: false,
    widgets: [
      {
        id: 'sw',
        title: 'Street View',
        type: 'streetView',
        cols: 6,
        splitStyle: {
          top: 0,
          left: 0,
          height: '70vh',
          width: '50vw',
        },
      },
      {
        id: 'vs',
        title: 'Video Stream',
        type: 'videoStream',
        cols: 6,
        splitStyle: {
          top: 0,
          right: 0,
          height: '70vh',
          width: '50vw',
        },
      },
      {
        id: 'mb',
        title: 'Mapbox',
        type: 'map',
        cols: 12,
        splitStyle: {
          bottom: 0,
          right: 0,
          left: 0,
          height: '30vh',
          width: '100vw',
        },
      }
    ],
    canvas: null,
    video: null,
    pc: null,
    pc1: null,
    pc2: null,
    startTime: null,
    selectedCodec: null,
  }),
  created() { },
  watch: {},
  computed: {
    ...mapGetters({
      currentFlux: 'flux/currentFlux',
      fluxItem: 'fluxItems/currentFluxItem',
    }),
    availableCodecs() {
      const { codecs } = RTCRtpReceiver.getCapabilities('video')
      const codecsList = []
      codecs.forEach(codec => {
        if (['video/red', 'video/ulpfec', 'video/rtx', 'video/flexfec-03'].includes(codec.mimeType)) {
          return;
        }
        const option = {};
        option.value = (codec.mimeType + ' ' + (codec.sdpFmtpLine || '')).trim();
        option.text = option.value;
        codecsList.push(option);
      });
      return codecsList;
    },
  },
  methods: {
    onLoaded(type) {
      if (type === 'streetView') {
        this.isStreetViewReady = true
        setTimeout(() => {
          this.canvas = document.getElementsByClassName('mapsImagerySceneScene__canvas')[0].getContext('webgl').canvas
          this.video = document.getElementById('video-stream')
          this.video.onresize = () => {
            console.log(`Remote video size changed to ${this.video.videoWidth}x${this.video.videoHeight}`)
            // We'll use the first onsize callback as an indication that video has started
            // playing out.
            if (this.startTime) {
              const elapsedTime = window.performance.now() - this.startTime
              console.log(`Setup time: ${elapsedTime.toFixed(3)}ms`)
              this.startTime = null
            }
          }
        }, 1000)
      } else if (type === 'map') {
        this.isMapboxReady = true
      }
    },
    onRefresh(type) {
      console.log(type)
    },
    onSplit(v) {
      this.split = v
    },
    start() {
      this.createPeerConnection()
      this.startTime = window.performance.now()
      const stream = this.canvas.captureStream(25)

      stream.getTracks().forEach((track) => {
        this.pc.addTrack(track, stream)
      })

      const [transceiver] = this.pc.getTransceivers();
      const codecs = RTCRtpReceiver.getCapabilities("video").codecs;
      transceiver.setCodecPreferences(this.sortByMimeTypes(codecs, ["video/VP9", "video/VP8"])); //"video/AV1", "video/H264", 

      return this.negotiate()
    },
    sortByMimeTypes(codecs, preferredOrder) {
      return codecs.sort((a, b) => {
        const indexA = preferredOrder.indexOf(a.mimeType);
        const indexB = preferredOrder.indexOf(b.mimeType);
        const orderA = indexA >= 0 ? indexA : Number.MAX_VALUE;
        const orderB = indexB >= 0 ? indexB : Number.MAX_VALUE;
        return orderA - orderB;
      });
    },
    stop() {
      // close transceivers
      if (this.pc.getTransceivers) {
        this.pc.getTransceivers().forEach((transceiver) => {
          if (transceiver.stop) {
            transceiver.stop()
          }
        })
      }

      // close local audio / video
      this.pc.getSenders().forEach((sender) => {
        sender.track.stop()
      })

      // close peer connection
      setTimeout(() => {
        this.pc.close()
      }, 500)
    },
    createPeerConnection() {
      const config = {
        sdpSemantics: 'unified-plan',
        iceServers: [{ urls: ['stun:stun.l.google.com:19302'] }]
      }

      this.pc = new RTCPeerConnection(config)

      // register some listeners to help debugging
      this.pc.addEventListener('icegatheringstatechange', () => {
        console.log("icegatheringstatechange", this.pc.iceGatheringState)
      }, false)

      this.pc.addEventListener('iceconnectionstatechange', () => {
        console.log("iceconnectionstatechange", this.pc.iceConnectionState)
      }, false)

      this.pc.addEventListener('signalingstatechange', () => {
        console.log("signalingstatechange", this.pc.signalingState)
      }, false)
      // connect stream
      this.pc.addEventListener('track', (evt) => {
        if (this.video.srcObject !== evt.streams[0]) {
          this.video.srcObject = evt.streams[0]

          if (this.video.paused) {
            document.getElementById('autoplay').style.display = 'block'
          }
        }
      })
    },
    negotiate() {
      return this.pc.createOffer().then((offer) => {
        return this.pc.setLocalDescription(offer)
      }).then(() => {
        // wait for ICE gathering to complete
        return new Promise((resolve) => {
          if (this.pc.iceGatheringState === 'complete') {
            resolve()
          } else {
            const checkState = () => {
              if (this.pc.iceGatheringState === 'complete') {
                this.pc.removeEventListener('icegatheringstatechange', checkState)
                resolve()
              }
            }
            this.pc.addEventListener('icegatheringstatechange', checkState)
          }
        })
      }).then(() => {
        const offer = this.pc.localDescription

        return fetch('http://192.168.0.16:8080/offer', { //http://192.168.0.15:8080/offer
          body: JSON.stringify({
            sdp: offer.sdp,
            type: offer.type,
            video_transform: 'detector'//''
          }),
          headers: {
            'Content-Type': 'application/json'
          },
          method: 'POST'
        })
      }).then((response) => {
        return response.json()
      }).then((answer) => {
        // Display the video codec that is actually used.
        setTimeout(async () => {
          const stats = await this.pc.getStats();
          stats.forEach(stat => {
            if (!(stat.type === 'outbound-rtp' && stat.kind === 'video')) {
              return;
            }
            const codec = stats.get(stat.codecId);
            console.log(stat)
            console.log('Actual video codec', 'Using ' + codec.mimeType +
              (codec.sdpFmtpLine ? ' ' + codec.sdpFmtpLine + ' ' : '') +
              ', payloadType=' + codec.payloadType + '.');
            if (stat.encoderImplementation) {
              console.log(' Encoder: "' + stat.encoderImplementation + '".')
            }
            if (stat.powerEfficientEncoder !== undefined) {
              console.log(' Power efficient: "' + stat.powerEfficientEncoder + '".')
            }
          });
        }, 1000);
        return this.pc.setRemoteDescription(answer)
      }).catch((e) => {
        alert(e)
      })
    }
  },
}
</script>

<style lang="scss" scoped>
#unsplit-btn {
  position: fixed;
  bottom: 10px;
  left: 25px;
  z-index: 200;
}

.f-title {
  font-size: 1.5rem !important;
  display: inline-block;
  vertical-align: middle;
}

.f-desc {
  display: inline-block;
  line-height: 1.3em;
  max-width: 500px;
  font-size: 16px;
}
</style>
